$(document).on("change", "#carrier_carrier_type", updateTrackingKeyList);

function updateTrackingKeyList(_e) {
  const preferredKeySelect = $("#carrier_preferred_tracking_key");
  const secondaryKeySelect = $("#carrier_secondary_tracking_key");
  preferredKeySelect.empty();
  secondaryKeySelect.empty();

  secondaryKeySelect.append('<option value=""></option>');

  const values = JSON.parse($("#possible_preferred_tracking_keys_input").val())[_e.target.value];
  values.forEach((x) => {
    preferredKeySelect.append(`<option value=${x}>${x}</option>`);
    secondaryKeySelect.append(`<option value=${x}>${x}</option>`);
  });
}
